import React from "react";
import { Box, Flex, IconTick, Image, LinkButton, Text, Truncate, } from "@catchoftheday/cg-components";
var StatusColour;
(function (StatusColour) {
    StatusColour["success"] = "primary";
    StatusColour["error"] = "error";
    StatusColour["info"] = "secondary";
    StatusColour["tertiary"] = "tertiary";
})(StatusColour || (StatusColour = {}));
export const ToastContent = ({ items, showCheckoutOnSuccess = false, }) => {
    const showCheckoutButton = showCheckoutOnSuccess && items.some((item) => item.status === "success");
    return (<Flex flexDirection={"column"}>
      {items.map(({ message, status, imageUrl, title, showTickOnSuccess }, index) => (<Flex key={`${title}-${index}`} pb="8px">
            <Box border="1px solid" borderColor="ui.borderColor">
              <Image src={imageUrl} alt={title} width="76px"/>
            </Box>
            <Box pl="12px" color="text">
              <Truncate m={0} color="text" fontWeight="normal" lines={2}>
                {title}
              </Truncate>
              <Flex alignItems="center">
                {showTickOnSuccess && status === "success" && (<IconTick mr="10px" mt="5px" width="15px" height="26px" aria-hidden="true" color="primary"/>)}
                <Text fontWeight="600" mt="5px" mb="0px" color={StatusColour[status]
                ? StatusColour[status]
                : StatusColour.info}>
                  {message}
                </Text>
              </Flex>
            </Box>
          </Flex>))}
      {showCheckoutButton && (<LinkButton sizeVariant="sm" mt="10px" href="/checkout/payment">
          Checkout
        </LinkButton>)}
    </Flex>);
};
//# sourceMappingURL=ToastContent.jsx.map